import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameVars } from "../../../GameVars";
import { LocksCounter } from "../hud/LocksCounter";
import { EventType } from "../../../Types";
import { BoardContainer } from "../BoardContainer";

export class Deck extends Phaser.GameObjects.Container {

    public static currentInstance: Deck;

    private meshes: Phaser.GameObjects.Mesh[];
    private finalMesh: Phaser.GameObjects.Mesh;
    private deckLink: Phaser.GameObjects.Image;
    private locksCounter: LocksCounter;
    private glowContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        Deck.currentInstance = this;

        this.setScale(.55);

        this.deckLink = new Phaser.GameObjects.Image(scene, 150, -150, "texture_atlas_1", "deck_link");
        this.deckLink.setScale(1 / this.scale);
        this.add(this.deckLink);

        this.meshes = [];
    }

    public startGame(): void {

        const state = GameVars.cardCrawlEngine.getState();
        const deck = state.deck;

        let n = state.upperTableau.reduce((count: number, item: CardCrawl.CardData) => item && item.uiData.spawned ? count + 1 : count, 0);
        n += deck.length;

        this.addMesh(true);

        for (let i = 0; i < n; i++) {
            this.addMesh(false);
        }

        if (n === 0) {
            this.deckLink.visible = false;
            this.dealFinalCard();
        }
    }

    public startTutorial(): void {

        let delay = 0;
        
        for (let i = 0; i < 54; i++) {
            this.scene.time.delayedCall(delay, () => {
                this.addMesh();
            }, [], this);
            delay += 15;
        }
    }

    public addLocksCounter(locksCounter: LocksCounter): void {

        this.locksCounter = locksCounter;
        this.add(this.locksCounter);
    }

    public addCards(n: number): void {

        for (let i = 0; i < n; i++) {
            this.addMesh(false);
        }

        this.bringToTop(this.locksCounter);

        this.deckLink.visible = true;
    }

    public dealFinalCard(): void {

        this.finalMesh = this.meshes.pop();

        const delay = 1000;

        // el escalado
        this.scene.tweens.add({
            targets: this.finalMesh.modelScale,
            x: 1.145,
            y: 1.145,
            z: 1.145,
            duration: 480,
            delay: delay,
            ease: Phaser.Math.Easing.Quintic.Out
        });

        this.scene.tweens.add({
            targets: this.finalMesh,
            y : -128,
            duration: 1280,
            delay: delay,
            ease: Phaser.Math.Easing.Quintic.Out
        });

        this.scene.tweens.add({
            targets: this.finalMesh.modelRotation,
            x: 0,
            duration: 640,
            delay: delay,
            ease: Phaser.Math.Easing.Linear
        });

        this.scene.tweens.add({
            targets: this.finalMesh.modelRotation,
            y: 0,
            duration: 640,
            delay: delay,
            ease: Phaser.Math.Easing.Linear
        });

        this.scene.tweens.add({
            targets: this.finalMesh.modelRotation,
            z: 0,
            duration: 1440,
            delay: delay,
            ease: Phaser.Math.Easing.Quartic.Out,
            onComplete: () => {
                this.addGlow();
            },
            onCompleteScope: this
        });  
    }

    public dealCard(onComplete?: any, onCompleteScope?: any): void {

        const mesh = this.meshes.pop();

        if (!mesh) {
            return;
        }

        if (this.meshes.length === 1) {

            this.dealFinalCard();

            this.scene.tweens.add({
                targets: this.deckLink,
                alpha: 0,
                duration: 400,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }

        // el escalado
        this.scene.tweens.add({
            targets: mesh.modelScale,
            x: 1.145,
            y: 1.145,
            z: 1.145,
            duration: 150,
            ease: Phaser.Math.Easing.Cubic.Out
        });

        this.scene.tweens.add({
            targets: mesh,
            y : -128,
            duration: 400,
            ease: Phaser.Math.Easing.Cubic.Out
        });

        this.scene.tweens.add({
            targets: mesh.modelRotation,
            x: 0,
            duration: 200,
            ease: Phaser.Math.Easing.Linear
        });

        this.scene.tweens.add({
            targets: mesh.modelRotation,
            y: 0,
            duration: 200,
            ease: Phaser.Math.Easing.Linear
        });

        this.scene.tweens.add({
            targets: mesh.modelRotation,
            z: 0,
            duration: 450,
            ease: Phaser.Math.Easing.Quartic.Out,
            onComplete: function(): void {

                if (onComplete) {
                    onComplete.apply(onCompleteScope, []);
                    mesh.destroy(); 
                }
            },
            onCompleteScope: this
        });  
    }

    public onGameOver(): void {

        // parar los tweens de glowcontainer
        if (this.glowContainer) {
            this.scene.tweens.killTweensOf(this.glowContainer);
        }
        this.scene.tweens.killTweensOf(this.finalMesh);

        if (GameVars.victory) {
           
            if (this.glowContainer) {
                this.scene.tweens.add({
                    targets: this.glowContainer,
                    alpha: 0,
                    duration: 300,
                    ease: Phaser.Math.Easing.Cubic.Out
                });
            }

            // animacion monedas que van al cofre

            const x = 60;
            const y = -460;

            const finalX = 345;
            const finalY = 460;

            const totalCoins = 20;

            for (let i = 0; i < totalCoins; i ++) {

                const coin = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", "coin");
                coin.angle = Phaser.Math.Between(-12, 12);
                coin.scale = 0;
                BoardContainer.currentInstance.add(coin);

                const angle = Phaser.Math.Between(0, 360);
                const dx = 50 * Math.cos(angle * Math.PI / 180);
                const dy = 50 * Math.sin(angle * Math.PI / 180);

                const chain = this.scene.tweens.chain({
                    targets: coin,
                    tweens: [
                        {
                            scaleX: 1.15,
                            scaleY: 1.15,
                            x: x + dx,
                            y: y + dy,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 300,
                            delay: Math.random() * 250,
                        },
                        {
                            x: finalX,
                            y: finalY,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 1250,
                            delay: Math.random() * 200,
                            onComplete: () => {
                                coin.destroy();
                            },
                            onCompleteScope: this
                        }
                    ]
                });
                chain.play();
            }

            // cuando acabe la animacion de las monedas
            // la carta final desaparece

            this.scene.tweens.add({
                targets: this.finalMesh,
                alpha: 0,
                duration: 450,
                ease: Phaser.Math.Easing.Cubic.Out,
                delay: 1600
            });

        } else if (GameVars.cardCrawlEngine.getState().deck.length === 0) {

            if (this.glowContainer) {
                this.scene.tweens.killTweensOf(this.glowContainer);

                this.scene.tweens.add({
                    targets: this.glowContainer,
                    alpha: 0,
                    duration: 300,
                    ease: Phaser.Math.Easing.Cubic.Out
                });
    
            }
            this.scene.tweens.killTweensOf(this.finalMesh);

            this.scene.tweens.add({
                targets:  this.locksCounter,
                alpha: 0,
                duration: 300,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: this.finalMesh,
                scaleX: 0,
                scaleY: 0,
                duration: 1200,
                ease: Phaser.Math.Easing.Back.In
            });

            this.scene.tweens.add({
                targets: this.finalMesh,
                alpha: 0,
                duration: 300,
                delay: 900,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }
    }

    private addMesh(finalGold?: boolean): void {

        const vertices = [
            -1, 1,
            1, 1,
            -1, -1,
            1, -1
        ];

        const uvs = [
            0, 0,
            1, 0,
            0, 1,
            1, 1
        ];

        const indicies = [ 0, 2, 1, 2, 3, 1 ];

        const i = this.meshes.length;

        const mesh = new Phaser.GameObjects.Mesh(this.scene, 0, -i * 1.35, finalGold ? "final_gold" : "card_back");
        mesh.addVertices(vertices, uvs, indicies);
        mesh.panZ(15);

        mesh.modelRotation.x = -.7;
        mesh.modelRotation.y = .2;
        mesh.modelRotation.z = .52;
        this.add(mesh);

        this.meshes.push(mesh);

        if (!finalGold) {
            GameVars.eventsDispatcher.dispatchEvent(new CardCrawl.Event(EventType.CARD_ADDED_TO_DECK, []));
        }
    }

    private addGlow(): void {

        if (GameVars.gameOver) {
            return;
        }

        this.glowContainer = new Phaser.GameObjects.Container(this.scene);
        this.glowContainer.setScale(1.58);
        this.glowContainer.alpha = 0;
        this.glowContainer.y = -128;

        const glow1 = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "hero_glow_1");
        this.glowContainer.addAt(glow1);

        const glow2 = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "hero_glow_2");
        this.glowContainer.addAt(glow2);

        const glow3 = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "hero_glow_3");
        this.glowContainer.add(glow3);

        this.addAt(this.glowContainer, 0);

        this.scene.tweens.add({
            targets: this.glowContainer,
            alpha: 1,
            duration: 1000,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete: () => {

                this.scene.tweens.add({
                    targets: glow3,
                    alpha: .5,
                    duration: 3000,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    yoyo: true,
                    repeat: -1
                });

                this.scene.tweens.add({
                    targets: this.glowContainer,
                    y: -128 - 12,
                    duration: 2000,
                    yoyo: true,
                    repeat: -1,
                    ease: Phaser.Math.Easing.Cubic.InOut
                });

                this.scene.tweens.add({
                    targets: this.finalMesh,
                    y: this.finalMesh.y - 12,
                    duration: 2000,
                    yoyo: true,
                    repeat: -1,
                    ease: Phaser.Math.Easing.Cubic.InOut
                });
            },
            onCompleteScope: this
        });
    }
}
